export default __webpack_public_path__ + "static/media/roadmap2@2x.66a2a440.png";